export default __webpack_public_path__ + "98d9c4e64fc70e5cdf3cbecd1da7d53f.svg";